module.exports = __webpack_public_path__ + "static/media/item_1_12_comp.7f51dc88.png";